import { render } from "./LinksBody.vue?vue&type=template&id=6f81cdca&scoped=true"
import script from "./LinksBody.vue?vue&type=script&lang=js"
export * from "./LinksBody.vue?vue&type=script&lang=js"

import "./LinksBody.vue?vue&type=style&index=0&id=6f81cdca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f81cdca"]])

export default __exports__